import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  CategoryDetailedView: {
    margin: "auto",
    width: "65%",
    fontFamily: "Arial, Helvetica, sans-serif",
    padding: "20px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  CategoryDetailedView_h1: {
    fontWeight: "bold",
    color: "#000",
  },
  insideCover: {
    display: "flex",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  insideCover_child1: {
    width: "70%",
    paddingRight: "2%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  insideCover_child2: {
    width: "28%",
    paddingRight: "2%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  insideCover_child3: {
    width: "30%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  imgCover: {
    padding: "3% 0",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  imgCover_video: {
    width: "100%",
    "&:hover": {
      opacity: "0.5",
      transition: "0.3s",
      cursor: "pointer",
    },
  },
  imgCover_img: {
    width: "100%",
    "&:hover": {
      opacity: "0.5",
      transition: "0.3s",
      cursor: "pointer",
    },
  },
  image: {
    width: "100%"
  },
  imgCover_h4: {
    fontWeight: "bolder",
    paddingTop: "1.1%",
    letterSpacing: "-1px",
  },
  imgCover_a: {
    color: "#0C0C0C",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline 1.3px",
      color: "#000",
    },
  },
  liveUpdates_a: {
    color: "#0C0C0C",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline 1.3px",
      color: "#000",
    },
  },
  liveUpdates_p: {
    borderBottom: "1px solid #dadada",
    padding: "0.5%",
  },
}));

const CategoryDetailedView = () => {
  const [title, setTitle] = useState("Title");
  const [blogData, setBlogData] = useState([]);

  const location = useLocation();

  const handleMouseOver = (event) => {
    event.target.play();
  };

  const handleMouseOut = (event) => {
    event.target.pause();
  };

  const classes = useStyles();

  useEffect(async () => {
    setTitle(location.state.name);
    console.log("page load");

    await axios
      .get(`http://54.166.132.110:5000/story/stories/${location.state.name}`)
      .then((res) => {
        setBlogData(res.data.data);
        console.log(res.data.data);
      });
  }, [location, title]);

  return (
    <>
      <div className={classes.CategoryDetailedView}>
        <h1 className={classes.CategoryDetailedView_h1}>
          {title || blogData[0].category}
        </h1>
        <div className={classes.insideCover}>
          <div className={classes.insideCover_child1}>
            {blogData && blogData.length > 0 && (
              <>
                <div className={classes.imgCover}>
                  <img
                    src={
                     // "https://media.cnn.com/api/v1/images/stellar/prod/2024-04-01t172328z-975838695-rc2pv6aqilkv-rtrmadp-3-climate-change-venezuela-fires.jpg?c=16x9&q=h_438,w_780,c_fill" ||
                      blogData[0].image
                    }
                    className={classes.image}
                    alt="cover"
                  />

                  <a href={`/story/${blogData[0].slug}`} className={classes.imgCover_a}>
                    <h4 style={{paddingTop:'15px'}}>{blogData[0].title}</h4>
                  </a>
                </div>
                <div className="liveUpdates">
                  {blogData.map((news, index) => (
                    <div key={index}>
                      <Link
                        to={`/story/${news.slug}`}
                        className={classes.liveUpdates_a}
                      >
                        <p>{news.title || "this is dummy text"}</p>
                      </Link>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
          <div className={classes.insideCover_child3}>
            {blogData.map((item,key) => {
              if(key<3){
                return (
                  <div className={classes.imgCover}>
                    <video
                      src="https://media.cnn.com/api/v1/loops/stellar/prod/al-quds-hp-2.mp4?c=original"
                      autoPlay={false}
                      muted
                      loop
                      onMouseEnter={handleMouseOver}
                      onMouseOut={handleMouseOut}
                      onmouseout="this.pause()"
                      ref={(video) => {
                        if (video) video.currentTime = 0.2;
                      }}
                      className={classes.imgCover_video}
                    ></video>

                    <Link
                      to={`/story/${item.slug}`}
                      className={classes.imgCover_a}
                    >
                      <h4>{item.title}</h4>
                    </Link>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryDetailedView;
